import { render, staticRenderFns } from "./envPatrolDetail.vue?vue&type=template&id=30bc4db3"
import script from "./envPatrolDetail.vue?vue&type=script&lang=js"
export * from "./envPatrolDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30bc4db3')) {
      api.createRecord('30bc4db3', component.options)
    } else {
      api.reload('30bc4db3', component.options)
    }
    module.hot.accept("./envPatrolDetail.vue?vue&type=template&id=30bc4db3", function () {
      api.rerender('30bc4db3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/ptr/envPatrolDetail.vue"
export default component.exports